import { FC, memo, useState, useEffect, useCallback } from 'react';
import { WallStreetIteration5 } from './WallStreetIterations/WallStreetIteration5';
import { WallStreetIteration6 } from './WallStreetIterations/WallStreetIteration6';
import { WallStreetIteration7 } from './WallStreetIterations/WallStreetIteration7';
import { WallStreetIterationMobile } from './WallStreetIterations/WallStreetIterationMobile';
import { WallStreetIterationMobile2 } from './WallStreetIterations/WallStreetIterationMobile2';
import { WallStreetIterationMobile3 } from './WallStreetIterations/WallStreetIterationMobile3';
import { WallStreetIterationMobile4 } from './WallStreetIterations/WallStreetIterationMobile4';
import { AuthIterationType } from './types';
import { isMobile } from '@benzinga/device-utils';

export const EdgeHardIterations: FC<AuthIterationType> = memo(
  ({
    allowClose,
    authMode,
    contentType,
    email,
    iterationVersion,
    nextUrl,
    onLogin,
    onRegister,
    onSessionLoad,
    onSocialClicked,
    placement,
  }) => {
    const [versionIndex, setVersionIndex] = useState<number | null>(iterationVersion ?? null);
    const showMobile = isMobile();

    const getVersionIndex = useCallback(
      (versionsCount: number) => {
        if (iterationVersion !== null && iterationVersion !== undefined) {
          return iterationVersion;
        }
        let versionIndex = Math.floor(Math.random() * versionsCount);
        versionIndex = versionIndex >= versionsCount || versionIndex < 0 ? 0 : versionIndex;
        return versionIndex;
      },
      [iterationVersion],
    );

    const versions = [WallStreetIteration5, WallStreetIteration6, WallStreetIteration7];

    const mobileVersions = [
      WallStreetIterationMobile,
      WallStreetIterationMobile2,
      WallStreetIterationMobile3,
      WallStreetIterationMobile4,
    ];

    useEffect(() => {
      const idx = getVersionIndex(versions.length);
      setVersionIndex(idx);
    }, [versions.length, getVersionIndex]);

    if (versionIndex !== null) {
      const SelectedVersion = versions[versionIndex];

      if (showMobile) {
        const mobileVersionIndex = versionIndex % mobileVersions.length;
        const SelectedMobileVersion = mobileVersions[mobileVersionIndex];
        return (
          <SelectedMobileVersion
            allowClose={allowClose}
            authMode={authMode}
            contentType={contentType}
            email={email}
            nextUrl={nextUrl}
            onLogin={onLogin}
            onRegister={onRegister}
            onSessionLoad={onSessionLoad}
            onSocialClicked={onSocialClicked}
            placement={placement}
          />
        );
      }

      return (
        <SelectedVersion
          allowClose={allowClose}
          authMode={authMode}
          contentType={contentType}
          email={email}
          nextUrl={nextUrl}
          onLogin={onLogin}
          onRegister={onRegister}
          onSessionLoad={onSessionLoad}
          onSocialClicked={onSocialClicked}
          placement={placement}
        />
      );
    } else {
      return null;
    }
  },
);

EdgeHardIterations.displayName = 'EdgeHardIterations';
